import Immutable from 'immutable';
import { createReducer } from '../utils';

const initialErrors = null;

export default createReducer(initialErrors, {
  RESET_SEARCH_RESULTS: () => initialErrors,
  UPDATE_FILTERS: () => initialErrors,
  RESET_FILTERS: () => initialErrors,
  REQUEST_VIEW_SEARCH: () => initialErrors,
  REQUEST_BANKRUPTCY_SEARCH: () => initialErrors,
  REQUEST_BANKRUPTCY_LOCAL_SEARCH: () => initialErrors,
  REQUEST_APPELLATE_SEARCH: () => initialErrors,
  REQUEST_CIVIL_SEARCH: () => initialErrors,
  REQUEST_CRIMINAL_SEARCH: () => initialErrors,

  REQUEST_CASE_DATA_OF_CASE_LOOKUP: () => initialErrors,

  RESET_VALIDATION_ERROR: () => initialErrors,
  VALIDATION_ERROR: (state, action) => Immutable.fromJS(action.errors),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/validationErrors.js